import React from "react";

const SvgComponent = props => (
  <svg
    width={61}
    height={61}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{`courseware/1`}</title>
    <defs>
      <path
        d="M0 29.837c0 16.097 13.051 29.148 29.149 29.148 16.099 0 29.148-13.051 29.148-29.148 0-16.099-13.049-29.15-29.148-29.15C13.051.687 0 13.738 0 29.837"
        id="a"
      />
      <path
        d="M0 29.837c0 16.097 13.051 29.148 29.149 29.148 16.099 0 29.148-13.051 29.148-29.148 0-16.099-13.049-29.15-29.148-29.15C13.051.687 0 13.738 0 29.837z"
        id="c"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 .313)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M18.672 25.367v-1.274c0-5.361 4.119-9.973 9.474-10.225 5.716-.27 10.435 4.284 10.435 9.943v9.955h-3.11v-9.727c0-3.77-2.95-7.003-6.718-7.07a6.845 6.845 0 0 0-6.971 6.846v1.552a1.555 1.555 0 1 1-3.11 0"
          fill="#55D5A9"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(1 .313)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          d="M27.51 48.328v4.718a1.867 1.867 0 0 0 3.734 0v-4.718a4.978 4.978 0 1 0-3.733 0zM14.447 34.38c0-.688.556-1.245 1.245-1.245h27.374c.687 0 1.245.556 1.245 1.245v27.374c0 .688-.557 1.245-1.245 1.245H15.69a1.244 1.244 0 0 1-1.245-1.245V34.38z"
          fill="#55D5A9"
          mask="url(#d)"
        />
      </g>
      <path
        d="M59.298 30.15c0 16.097-13.05 29.147-29.148 29.147C14.05 59.297 1 46.247 1 30.15 1 14.05 14.05 1 30.15 1c16.098 0 29.148 13.05 29.148 29.15z"
        stroke="#FEAD64"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export default SvgComponent;
